// extracted by mini-css-extract-plugin
export default {"pageBackground":"maGCCv4kjL9O1p6EQSQm__pageBackground___","whiteBackground":"C6H5ddvSi4zcGJ_ah9BJ__whiteBackground___","subscriptionPage":"oT5w6WfyQOsY0GRs2Bhe__subscriptionPage___"};